<template>
  <div>
    <!-- <iframe id="iframe" style="width: 100%; height: 1000px;"></iframe> -->
  </div>
</template>

<script>
// import Axios from "axios";

import { PDFDocument, rgb } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";

import image from "../../../assets/img/new-certificado.png";
import unb from "../../../assets/font/unb_pro_bold.otf";
import unbNormal from "../../../assets/font/unb.ttf";


const fetchBinaryAsset = asset => fetch(asset).then(res => res.arrayBuffer());

export default {
  props: {
    user: Object
  },
  data() {
    return {
      pdf: null
    };
  },
  methods: {
    quebrarTexto(texto, maxCaracteres) {
      const palavras = texto.split(' ');
      const linhas = [];
      let linhaAtual = '';
      
      for (const palavra of palavras) {
        if ((linhaAtual + palavra).length <= maxCaracteres) {
          linhaAtual += (linhaAtual ? ' ' : '') + palavra;
        } else {
          if (linhaAtual) {
            linhas.push(linhaAtual);
            linhaAtual = palavra;
          } else {
            linhas.push(palavra);
          }
        }
      }
      
      if (linhaAtual) {
        linhas.push(linhaAtual);
      }
      
      return linhas;
    },
    renderInIframe(pdfBytes) {
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      this.pdf = blobUrl;
      a.href = blobUrl;
      a.download = "certificado.pdf";
      a.click();
      // document.getElementById("iframe").src = blobUrl;
      this.user = {};
    },
    async gerarPdf() {
      
      const pdfDoc = await PDFDocument.create();

      const [jpgImageBytes, fontUnb, fontUnbNormal] = await Promise.all([
        fetchBinaryAsset(image),
        fetchBinaryAsset(unb),
        fetchBinaryAsset(unbNormal),

      ]);

      const pngImage = await pdfDoc.embedPng(jpgImageBytes);

      pdfDoc.registerFontkit(fontkit);
      const customFont = await pdfDoc.embedFont(fontUnb);
      const customFontNormal = await pdfDoc.embedFont(fontUnbNormal);



      const textSize = 21;

      const text = this.user.nome;

      const textWidth = customFont.widthOfTextAtSize(text, textSize);

      const text2 = this.user.curso;
      const textWidth2 = customFont.widthOfTextAtSize(text2, textSize);

      const text3 = this.user.modalidade;
      const textWidth3 = customFont.widthOfTextAtSize(text3, textSize);


      const page = pdfDoc.addPage([842, 595]); // Orientação paisagem

      page.drawImage(pngImage, {
        x: 0,
        y: 0,
        width: 842,
        height: 595
      });

      page.drawText(text, {
        x: (842 - textWidth) / 2 + 20,
        y: 370,
        size: textSize,
        font: customFont,
        color: rgb(0, 0, 0)
      });

      page.drawText(this.user.cpf.toString(), {
        x: 260,
        y: 340,
        size: 20.5,
        font: customFont,
        color: rgb(0, 0, 0)
      });

      page.drawText(text2, {
        x: (842 - textWidth2) / 2 + 20,
        y: 280,
        size: textSize,
        font: customFont,
        color: rgb(0, 0, 0)
      });

      page.drawText(text3, {
        x: (842 - textWidth3) / 2 + 20,
        y: 220,
        size: textSize,
        font: customFont,
        color: rgb(0, 0, 0)
      });

      page.drawText(this.user.baseLegal.toString(), {
        x: 378,
        y: 162,
        size: 15,
        font: customFontNormal,
        color: rgb(0, 0, 0)
      });

      page.drawText(new Date(this.user.data).toLocaleDateString("pt-BR"), {
        x: 307,
        y: 94,
        size: 14,
        font: customFont,
        color: rgb(0, 0, 0)
      });

      page.drawText(this.user.exame.toString(), {
        x: 139,
        y: 94,
        size: 10,
        font: customFont,
        color: rgb(0, 0, 0)
      });

      // Adicionar página com conteúdo programático APÓS a primeira página
      if (this.user.conteudoProgramatico && this.user.conteudoProgramatico.length > 0) {
        
        const pag2 = pdfDoc.addPage();
        const { height: height2 } = pag2.getSize();
        
        // Título da página
        pag2.drawText('CONTEÚDO PROGRAMÁTICO', {
          x: 50,
          y: height2 - 40,
          size: 14,
          font: customFont,
          color: rgb(0, 0, 0)
        });
        
        // Nome real do curso (não a modalidade)
        const courseName = this.user.modalidade ? `${this.user.curso} ${this.user.modalidade}` : this.user.curso;
          
        pag2.drawText(`Curso: ${courseName}`, {
          x: 50,
          y: height2 - 65,
          size: 11,
          font: customFontNormal,
          color: rgb(0, 0, 0)
        });
        
        pag2.drawText(`Carga Horária: ${this.user.hora} horas`, {
          x: 50,
          y: height2 - 85,
          size: 11,
          font: customFontNormal,
          color: rgb(0, 0, 0)
        });
        
        let currentY = height2 - 110;
        let paginaAtual = pag2;
        
        for (const modulo of this.user.conteudoProgramatico) {
          // Verificar se precisamos de uma nova página (ajustado para caber mais conteúdo)
          if (currentY < 60) {
            paginaAtual = pdfDoc.addPage();
            currentY = height2 - 50;
          }
          
          // Nome do módulo
          paginaAtual.drawText(modulo.name, {
            x: 50,
            y: currentY,
            size: 12,
            font: customFont,
            color: rgb(0, 0, 0)
          });
          
          currentY -= 18;
          
          // Apenas as lições do módulo (sem descrições)
          if (modulo.lessons && modulo.lessons.length > 0) {
            for (const lesson of modulo.lessons) {
              if (currentY < 40) {
                paginaAtual = pdfDoc.addPage();
                currentY = height2 - 50;
              }
              
              paginaAtual.drawText(`${lesson.name}`, {
                x: 65,
                y: currentY,
                size: 10,
                font: customFontNormal,
                color: rgb(0, 0, 0)
              });
              
              currentY -= 15;
            }
          }
          
          currentY -= 10; // Espaço entre módulos
        }
      }

      const pdfBytes = await pdfDoc.save();
      this.renderInIframe(pdfBytes);
    }
  },
  watch: {
    user() {
      this.gerarPdf();
    }
  }
};
</script>

<style>
</style>
